import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedComponentsModule } from '@symphony-solo/shared/components/src';
import { EllipsisModule } from 'ngx-ellipsis';
import { BasketSectionComponent } from './basket-section';
import { MainHeaderComponent } from './main-header';
import { LoadingSpinnerService } from './services/loading-spinner.service';
import { TotalPriceBarComponent } from './total-price-bar';

@NgModule({
  imports: [CommonModule, IonicModule, EllipsisModule, SharedComponentsModule],
  declarations: [MainHeaderComponent, BasketSectionComponent, TotalPriceBarComponent],
  exports: [MainHeaderComponent, BasketSectionComponent, TotalPriceBarComponent],
})
export class SmartComponentsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SmartComponentsModule,
      providers: [LoadingSpinnerService],
    };
  }
}
